import { Type } from 'class-transformer'
import { Money } from '@app/features/scope-overview/model/money.model'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ThirdPartyCost } from '@app/core/model/third-party-cost.model'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { UserComment } from '@core/model/comment.model'

export class DeliverableSection {
  id!: number
  order!: number
  name!: string
  currencyUnit!: string
  @Type(() => ScopeComponent) components: ScopeComponent[]
  @Type(() => UserComment) comments!: UserComment[]
  @Type(() => ThirdPartyCost) thirdPartyCosts: ThirdPartyCost[] = []
  @Type(() => Date) startDate: Date
  @Type(() => Date) endDate: Date
  deliverableId?: number

  getTotalSellingPrice = (ctx: any = {}, deliverable: Deliverable) => {
    let total = new Money(0, this.currencyUnit)
    const components = this.getComponents(deliverable)
    for (let i = 0; i < components.length; i++) {
      const component = components[i]
      const totalUserSellingPrice = component.getTotalSellingPrice(ctx)
      if (totalUserSellingPrice == null) return null
      if (totalUserSellingPrice.currency !== this.currencyUnit) continue
      total = total.add(totalUserSellingPrice)
    }
    for (let j = 0; j < this.thirdPartyCosts.length; j++) {
      const tpcPrice = this.thirdPartyCosts[j].calculateSellingPrice()
      if (tpcPrice.currency !== this.currencyUnit) continue
      total = total.add(tpcPrice)
    }
    return total
  }

  getTotalRateCardHours = (deliverable: Deliverable) => {
    const components = this.getComponents(deliverable)
    return components.map((component) => component.rateCardTotalHours).reduce((acc, next) => acc + next, 0)
  }

  getTotalScopeMarkHours = (deliverable: Deliverable) => {
    const components = this.getComponents(deliverable)
    return components.map((component) => component.scopeMarkTotalHours).reduce((acc, next) => acc + next, 0)
  }

  totalScopeMarkSellingPrice(deliverable: Deliverable) {
    let total = new Money(null, this.currencyUnit)
    const components = this.getComponents(deliverable)
    for (let i = 0; i < components.length; i++) {
      const component = components[i]
      if (component.totalScopeMarkSellingPrice() == null) return null
      if (component.totalScopeMarkSellingPrice().currency !== this.currencyUnit) continue
      total = total.add(component.totalScopeMarkSellingPrice())
    }
    return total
  }

  getComponents = (deliverable: Deliverable) => {
    return this.components || deliverable?.components?.filter((c) => c.section?.id === this.id) || []
  }

  calculateThirdPartyCosts(deliverable: Deliverable) {
    let total = new Money(null, this.currencyUnit)
    const components = this.getComponents(deliverable)
    for (let i = 0; i < components.length; i++) {
      const component = components[i]
      if (component.thirdPartyCostTotal().currency !== this.currencyUnit) continue
      total = total.add(component.thirdPartyCostTotal())
    }
    for (let t = 0; t < this.thirdPartyCosts.length; t++) {
      const tpcPrice = this.thirdPartyCosts[t].calculateSellingPrice()
      if (tpcPrice.currency !== this.currencyUnit) continue
      total = total.add(tpcPrice)
    }
    return total
  }

  getTpcValueTotal() {
    let total = new Money(0, this.currencyUnit)
    this.thirdPartyCosts?.forEach((tpc: any) => {
      const tpcPrice = tpc.calculateCostPrice()
      if (tpcPrice.currency !== this.currencyUnit) return
      total = total.add(tpcPrice)
    })
    return total
  }
}
